import { SIDEBAR_DEFAULT, SIDEBAR_TOGGLE } from '../actions/sidebar.types';
import routeConfig from '../../app/routes.global';

export default function sidebarReducer(state = SIDEBAR_DEFAULT, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SIDEBAR_TOGGLE:
      if (typeof payload.visible === 'undefined') {
        payload.visible = !state.visible;
      }
      return {
        ...SIDEBAR_DEFAULT,
        ...state,
        ...payload,
      };
    default:
      if (typeof routeConfig[type] !== 'undefined') {
        return {
          ...state,
          visible: false,
        };
      }
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/sidebar.js